import { LoginResponseDto } from '../lib/api';

export function checkPermission(session: LoginResponseDto, feature?: string) {
    if (session.scope?.organization) {
        return true;
    }
    if (feature) {
        return session.scope?.branches.some((branch) =>
            branch.access.some((permission) => permission.startsWith(`${feature}:`) || permission.startsWith('*:')),
        );
    }
    return false;
}
